import React from "react";
import { Dialog } from "./Dialog";
import { css } from "aphrodite-jss";
import { styles } from "./ReportDialogStyles";
import fileDownload from 'js-file-download'
import { RequestState } from "src/models/RequestState";
import axios from "axios";
import { Api } from "src/core/api";
import { Application } from "src/core/application";

interface IReportDialogProps {
    isOpen: boolean;
    onClose: any;
    reportPayload: any;
}

class ReportDialogState {
    public readonly description: string = "" ;
    public requestState: RequestState = RequestState.NOT_ASKED;
    public error: string = "";
}

export class ReportDialog extends React.Component<IReportDialogProps,ReportDialogState> {

    constructor(props: IReportDialogProps){
        super(props);
        this.state = new ReportDialogState();
    }

    public render() {

        let requestStatusContent;

        if(this.state.requestState === RequestState.LOADING){
            requestStatusContent = (
                <div>
                    Uploading
                </div>
            )
        }else if(this.state.requestState === RequestState.ERROR){
            requestStatusContent = (
                <div>
                    {this.state.error}
                </div>
            );
        }else{
            requestStatusContent = (<div>

            </div>)
        }

        return (<Dialog isOpen={this.props.isOpen} onClose={this.props.onClose} > 
            <div id="container" className={css(styles.container)}>
                <React.Fragment>
                <div className={css(styles.content)} >
                    <div id="title" className={css(styles.title)}>
                        Send a report
                    </div>
                    <textarea value={this.state.description}
                            onChange={this.handleChange}
                            placeholder={"Please describe your bug report"}
                            className={css(styles.description)}
                            />

                    <div id="reportContainer" className={css(styles.reportContainer)}  >
                        <div>
                            Report:
                        </div>
                        <div className={css(styles.reportValue)} onClick={this.onReportClick}>
                            report.zip
                        </div>
                    </div>
                    <div id="submit_button" className={css(styles.button)} onClick={this.onSubmitButtonClicked} >
                        Submit
                    </div>
                    <div>
                        {requestStatusContent}
                    </div>
                </div>
                </React.Fragment>
            </div>
        </Dialog>);
    }

    private handleChange = (event: any) => {
        const newState = {...this.state, description: event.target.value}
        this.setState(newState);
    }

    private onReportClick = (event: any) => {
        fileDownload(this.props.reportPayload, "report.zip");
    }

    private onSubmitButtonClicked = (event: any) => {
        const formData = new FormData();
        formData.append("description", this.state.description);
        const username = Application.getUserName();
        if(username){
            formData.append("username", username);
        }
        formData.append("report",this.props.reportPayload);
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        const newState = {...this.state,requestState: RequestState.LOADING}
        this.setState(newState);
        axios.post(`${Api.getEndPoint()}/report`,formData,config).then((res)=>{
            if(res.status === 200){
                this.setState({...this.state, requestState: RequestState.NOT_ASKED});
                this.props.onClose();
            }else{
                this.setState({...this.state, requestState: RequestState.ERROR, error: res.statusText});
            }
        }).catch((error)=>{
            this.setState({...this.state, requestState: RequestState.ERROR, error: error.toString()});
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/dialogs/ReportDialog.tsx